import React from "react";
import { FiMail, FiDownload } from "react-icons/fi";

function CTASection() {
  return (
    <section
      id="contact"
      className="bg-transparent p-4 sm:p-8 font-sans border-t border-slate-900/10 mt-12 mb-8"
    >
      <div className="mx-auto max-w-7xl w-full">
        <div className="w-full bg-slate-900 border-2 border-slate-950 rounded-3xl p-8 lg:p-16 text-center relative overflow-hidden bg-grid-pattern shadow-[6px_6px_0px_0px_#ccd5ae] hover:shadow-[10px_10px_0px_0px_#d4a373] transition-all duration-300 hover:-translate-y-0.5 group">
          {/* Ambient Background */}
          <div className="absolute inset-0 bg-gradient-to-br from-gsf-bronze/5 via-transparent to-transparent pointer-events-none"></div>

          <div className="relative z-10 max-w-2xl mx-auto space-y-6">
            {/* Badge */}
            <span className="inline-block rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs font-mono font-bold uppercase tracking-widest text-gsf-bronze">
              Next Opportunity
            </span>

            {/* Heading */}
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-white leading-tight">
              Let's Build Something{" "}
              <span className="text-gsf-bronze">Meaningful.</span>
            </h2>

            {/* Description */}
            <p className="mx-auto max-w-xl text-sm sm:text-base font-medium leading-relaxed text-slate-400">
              I'm always interested in collaborating on meaningful software
              projects where I can contribute through backend engineering,
              scalable system architecture, and production-ready digital
              solutions.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-wrap items-center justify-center gap-4 pt-4">
              {/* Contact: Mengarah langsung ke Gmail Anda via mailto */}
              <a
                href="mailto:gjoefandi@gmail.com"
                className="inline-flex items-center gap-2 rounded-xl border-2 border-slate-900 bg-white px-6 py-3.5 text-sm font-bold text-slate-900 shadow-[4px_4px_0px_0px_#faedcd] transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[6px_6px_0px_0px_#d4a373] active:translate-y-0"
              >
                <FiMail className="text-base" />
                Get in Touch
              </a>

              {/* Resume: Mengarah ke link Google Drive dummy Anda (Terbuka di tab baru) */}
              <a
                href="https://drive.google.com/file/d/1i3pRXHglT8azSPfsAFw5LHGXRmEqowqo/preview"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-xl border-2 border-white/20 bg-transparent px-6 py-3.5 text-sm font-bold text-white transition-all duration-200 hover:border-white hover:bg-white/5"
              >
                <FiDownload className="text-base" />
                Download Resume
              </a>
            </div>
          </div>

          {/* Decorative Code */}
          <div className="absolute bottom-4 right-6 hidden select-none font-mono text-[10px] text-slate-600 md:block">
            // Always building.
          </div>
        </div>
      </div>
    </section>
  );
}

export default CTASection;
